// BOTÕES WHATSAPP + LIGAR DO TOPO NO CELULAR (cs1859, SD-0020 / sugestão #212). Só renderiza para quem
// passa em mostraWhatsELigarNoCelular (utils/topoContato.ts) — quem chama faz o gate, os demais sites
// não ganham nenhum nó no HTML. Links nativos: tel: e WhatsApp abrem no próprio toque, sem o
// window.open atrasado do topo, que o navegador do celular pode bloquear.
import { FaPhoneAlt, FaWhatsapp } from 'react-icons/fa';
import { MaskPhone } from '../../../utils/FunctionsGlobals';
import { trackMetaEvent } from '../../../utils/metaPixel';
import styles from './WhatsELigarCelular.module.css';

const POSICAO = {
    // Topo.tsx: sobre a barra, à esquerda da logo centralizada; aparece até 850px
    barra: styles.barra,
    // welcome2: entre a logo e o ☰; aparece até 768px, onde o telefone sai dessa cópia do topo
    linha: styles.linha,
    // ficha modelo 1: à direita do ☰, dentro da caixa de opções; aparece até 850px
    ficha: styles.ficha,
};

const WhatsELigarCelular: React.FC<{
    site: any;
    urlWhatsapp?: string;
    cor?: string;
    posicao: keyof typeof POSICAO;
}> = ({ site, urlWhatsapp, cor, posicao }) => {
    const telefone = site?.Dados?.tel1;

    const registrar = (metodo: 'whatsapp' | 'phone') => {
        void import('../../whatsAppButton/WhatsAppButton')
            .then(({ trackLead }) => {
                trackLead(site, null);
            })
            .catch(() => undefined);
        trackMetaEvent(site, 'Contact', { content_name: 'Contato do cabeçalho', contact_method: metodo, content_category: 'header' });
    };

    return (
        <div className={`${styles.contato} ${POSICAO[posicao]}`}>
            {urlWhatsapp ? (
                <a
                    className={`${styles.botao} ${styles.whatsapp}`}
                    href={urlWhatsapp}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={`Chamar no WhatsApp ${MaskPhone(telefone)}`}
                    title="Chamar no WhatsApp"
                    onClick={() => registrar('whatsapp')}
                >
                    <FaWhatsapp aria-hidden="true" size={22} />
                </a>
            ) : null}
            <a
                className={`${styles.botao} ${styles.ligar}`}
                style={{ color: cor }}
                href={`tel:+55${telefone?.replace(/\D/g, '')}`}
                aria-label={`Ligar para ${MaskPhone(telefone)}`}
                title="Ligar"
                onClick={() => registrar('phone')}
            >
                <FaPhoneAlt aria-hidden="true" size={16} />
            </a>
        </div>
    );
};

export default WhatsELigarCelular;
